import PropTypes from "prop-types"
import { Work } from "@mui/icons-material"
import { PERMISSION_LEVEL, ROLE } from "helpers/shapes"
import Resource from "../resource"
import { getPortfolioMenuItems } from "modules/portfolio-root/selectors/menu"

export default function Portfolio({
  resource,
  permissionLevel,
  models,
  trackResourceEvent,
  toggleFavorite,
  account,
  isOpPro,
  dispatch,
}) {
  return <Resource {...{
    account,
    trackResourceEvent,
    toggleFavorite,
    url: `/${account}/p/${resource.alias || resource.id}`,
    resource,
    resourceType: "portfolio",
    resourceIcon: <Work />,
    permissionLevel,
    menuItems: getPortfolioMenuItems(account, resource, models, isOpPro),
    models,
    isOpPro,
    dispatch,
  }}
  />
}

Portfolio.propTypes = {
  handlers: PropTypes.object.isRequired,
  resource: PropTypes.object.isRequired,
  permissionLevel: PERMISSION_LEVEL.isRequired,
  models: PropTypes.object.isRequired,
  openDialog: PropTypes.func.isRequired,
  trackResourceEvent: PropTypes.func.isRequired,
  toggleFavorite: PropTypes.func.isRequired,
  account: PropTypes.string.isRequired,
  linkedToAlphaTheory: PropTypes.bool,
  isOpPro: PropTypes.bool.isRequired,
  role: ROLE.isRequired,
  dispatch: PropTypes.func,
  intradayAccountEnabled: PropTypes.bool,
}
